import styled from '@emotion/styled';
import theme from '@vromo/ui/components/theme';

export default {
    container: {
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 20,
        marginBottom: 30,
        backgroundColor: 'white'
    },
    overlayTitle: {
        width: '100%',
        textAlign: 'center',
        fontSize: '28px',
        letterSpacing: 1.1,
        fontWeight: 'bold',
        color: theme.darkText
    },
    iconContainer: {
        width: 64,
        height: 64
    },
    descriptionContainer: {
        marginTop: 16
    },
    description: {
        color: theme.darkText
    },
    activationTitle: {
        marginTop: 20,
        marginBottom: 12,
        color: theme.darkText
    },
    fleetName: {
        fontWeight: 'bold',
        color: theme.darkText
    },
    fleetListItem: {
        marginLeft: 12,
        color: theme.darkText
    }
};

export const CheckIcon = styled.svg`
    fill: none;
    stroke: #55cc55;
    stroke-width: 4px;
`;
